import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faUsers,
  faMoneyBillWave,
  faExchangeAlt,
  faChartLine,
  faCog,
  faBars,
  faUserShield,
  faClipboardList,
  faWallet,
  faArrowUp,
  faTimes // ✅ ADD CLOSE ICON
} from '@fortawesome/free-solid-svg-icons';
import stoneforexLogo from '../../../../assets/stoneforex-logo.png';
import styles from './AdminSidebar.module.css';

const menuItems = [
  { path: '/admin', icon: faTachometerAlt, label: 'Dashboard', exact: true },
  { path: '/admin/users', icon: faUsers, label: 'User Management' },
  { path: '/admin/deposits', icon: faMoneyBillWave, label: 'Deposit Requests' },
  { path: '/admin/withdrawals', icon: faArrowUp, label: 'Withdrawal Requests' },
  { path: '/admin/transactions', icon: faExchangeAlt, label: 'Transactions' },
  { path: '/admin/trading-accounts', icon: faChartLine, label: 'Trading Accounts' },
 { path: '/admin/upi-settings', icon: faWallet, label: 'UPI Settings' },
{ path: '/admin/bank-settings', icon: faWallet, label: 'Bank Settings' },
{ path: '/admin/crypto-settings', icon: faWallet, label: 'Crypto Settings' },
  { path: '/admin/settings', icon: faCog, label: 'System Settings' }
];

function AdminSidebar({ collapsed, onToggle }) {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false); // ✅ ADD MOBILE STATE

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  // ✅ MOBILE FUNCTIONS
  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileClose = () => {
    setMobileOpen(false);
  };

  const handleLinkClick = () => {
    // Close mobile menu when link is clicked
    setMobileOpen(false);
  };

  return (
    <>
      {/* ✅ MOBILE HAMBURGER BUTTON */}
      <button 
        className={styles.mobileMenuBtn} 
        onClick={handleMobileToggle}
        aria-label="Open mobile menu"
      >
        <FontAwesomeIcon icon={faBars} />
      </button>

      {/* ✅ MOBILE OVERLAY */}
      {mobileOpen && (
        <div 
          className={`${styles.mobileOverlay} ${styles.active}`}
          onClick={handleMobileClose}
        />
      )}

      {/* ✅ SIDEBAR WITH MOBILE CLASSES */}
      <aside className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''} ${mobileOpen ? styles.mobileOpen : ''}`}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.logoSection}>
            <img src={stoneforexLogo} alt="StoneForex Admin" className={styles.logo} />
            {!collapsed && <span className={styles.title}>Admin Panel</span>}
          </div>
          
          {/* ✅ DESKTOP TOGGLE BUTTON */}
          <button className={styles.toggleBtn} onClick={onToggle}>
            <FontAwesomeIcon icon={faBars} />
          </button>
          
          {/* ✅ MOBILE CLOSE BUTTON */}
          <button className={styles.mobileCloseBtn} onClick={handleMobileClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Admin Info */}
        {!collapsed && (
          <div className={styles.adminInfo}>
            <div className={styles.adminAvatar}>
              <FontAwesomeIcon icon={faUserShield} />
            </div>
            <div className={styles.adminDetails}>
              <h4>Super Admin</h4>
              <p>System Administrator</p>
            </div>
          </div>
        )}

        {/* Navigation */}
        <nav className={styles.navigation}>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`${styles.navItem} ${
                isActive(item.path, item.exact) ? styles.active : ''
              }`}
              title={collapsed ? item.label : ''}
              onClick={handleLinkClick} // ✅ CLOSE MOBILE MENU ON CLICK
            >
              <FontAwesomeIcon icon={item.icon} className={styles.icon} />
              {!collapsed && <span className={styles.label}>{item.label}</span>}
            </Link>
          ))}
        </nav>

        {/* Footer */}
        <div className={styles.footer}>
          <div className={styles.version}>
            {!collapsed && <span>StoneForex Admin v1.0</span>}
          </div>
        </div>
      </aside>
    </>
  );
}

export default AdminSidebar;
